import { crudService, partoService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const partoAction = {
    getParto,
    getPartoByFazenda,
    getPartoById,
    onChangeProps,
    editPartoInfo,
    createParto,
    deletePartoById,
    clear
};
function getParto(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'partos';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changePartosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getPartoByFazenda(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'partos/fazenda/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changePartosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createParto(payload) {
    return dispatch => {
        let apiEndpoint = 'partos/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);

                    dispatch(createUserInfo());
                    alerts.success(ret.message, '/partos');

                } else {
                    alerts.warning(JSON.parse(response.request.responseText).Message);
                }
            })
    }
}
function getPartoById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'partos/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editPartosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editPartoInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'partos/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    alerts.success(ret.message, '/partos');

                } else {
                    alerts.warning(response.request.responseText);
                }
            })
    }
}
function deletePartoById(id, showWaiting, id_fazenda) {
    return dispatch => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (showWaiting) {
                    alerts.waiting();
                }
                if (willDelete.value) {
                    let apiEndpoint = 'partos/' + id;
                    partoService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deletePartosDetails());
                                dispatch(partoAction.getPartoByFazenda(id_fazenda));
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                alerts.success(ret.message, '/partos');
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    };
}

export function changePartosList(parto) {
    return {
        type: "FETECHED_ALL_PARTO",
        parto: parto
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editPartosDetails(parto) {
    return {
        type: "PARTO_DETAIL",
        id: parto.id,
        id_animal: parto.id_animal,
        id_fazenda: parto.id_fazenda,
        data: parto.data,
        id_touro: parto.id_touro,
        tipo: parto.tipo,
        data_cadastro: parto.data_cadastro,
        usuario_cadastro: parto.usuario_cadastro,
        data_exclusao: parto.data_exclusao,
        usuario_exclusao: parto.usuario_exclusao,
        nascido_morto: parto.nascido_morto,
        valido: parto.valido,
        fazenda: parto.fazenda
    }
}
export function updatedUserInfo() {
    return {
        type: "PARTO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "PARTO_CREATED_SUCCESSFULLY"
    }
}
export function deletePartosDetails() {
    return {
        type: "DELETED_PARTO_DETAILS"
    }
}
export function clear() {
    return {
        type: "PARTO_CLEAR"
    };
}